<wma-icon class="text-danger-500 size-5" name="exclamation-circle" />
<p class="text-danger-500 mt-2 text-sm font-semibold">
  <ng-content />
</p>
@if (retry(); as retryFn) {
  <button type="button" wma-button color="white" class="mt-4" (click)="retryFn()">
    {{ 'COMMON.RETRY' | translate }}
  </button>
}
